import React, { useState, useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/ducks";
import Slider from "react-slick";
//components
import Text from "components/Text";
import { InputYesOrNo } from "../../Input/YesOrNo";
import { Visibility } from "components/Visibility";
import { Column, Row } from "components/Layout/Grid";
import CDCloseButton from 'components/CDCloseButton';
import { toastify } from "components/Toastify/utils";
import { PriceHistoryTable } from "./PriceHistoryTable";
import {
  ItemInfo,
  PriceModal,
  PrinceInfo,
  HeaderText,
  HeaderTitle,
  HeaderContent,
  SuggestedPrice,
  ModalContainer,
} from "./style";
//assets
import "../../../../../Quotes/styles.scss";
import priceHistoryBtn from "img/price-history-icon-inverted.svg";
//utils
import { DateOutputStr } from "utils/DateOutput";
import { IsNullOrEmpty } from "utils/StringNullOrEmpty";
import { currencyOutputNumber } from "utils/CurrencyOutput";
import QuoteSevices from "../../../../../../services/quote.service";
import quoteMapProductSevices from "services/quoteMapProduct.service";
//interfaces
import { IUpdateCompetitorPrice } from "models/MapProduct";
import { IGroupPriceHistory, PriceHistoryModalProps, settings } from "./interface";
//context
import { useDetailsQuoteContext } from "contexts/DetailsQuote";
import { ProductSegmentDescription, segmentsMinimumPriceLock2 } from "pages/Quotes/components/Tags/interface";

const PriceHistoryModal = ({
  item,
  quoteDetail,
  onCloseAction,
  ableNegotiacionBtn,
}: PriceHistoryModalProps) => {
  const dispatch = useDispatch();
  const { resetItemPriceHistory } = useDetailsQuoteContext();

  const user = useSelector((state: RootState) => state.user);
  const [tableData, setTableData] = useState<IGroupPriceHistory>();
  const [finishedLoadingTableData, setFinishedLoadingTableData] = useState(false);
  const [competitorPrice, setCompetitorPrice] = useState<{ price: string; date: string; }>();
  const [visible, setVisible] = useState(false);

  const stock = item?.itemStock?.find((elem: any) => elem.local === item?.distributionCenter);
  const checkSuggestedPrice = Number(stock?.suggestedPrice) !== 0;
  const checkMinimumPriceLock1 = Number(stock?.minimumPriceLock1) !== 0;

  const _item = item;

  useEffect(() => {
    if (item.competitorPrice) {
      setCompetitorPrice({
        price: currencyOutputNumber(Number(item.competitorPrice?.price ?? competitorPrice?.price)),
        date: DateOutputStr(competitorPrice?.date || item.competitorPrice?.date, 'dd/MM/yyyy - HH:mm')
      });
    }
  }, [item.competitorPrice]);

  const applyUnitPrice = (unitPrice: any) => {
    if (_item.factoryPrice > 0 && unitPrice > _item.factoryPrice) {
      unitPrice = _item.factoryPrice;
    }

    dispatch({ type: "SET_UNIT_PRICE_VALUE", data: { unitPrice: String(unitPrice), item: _item } });

    resetItemPriceHistory();
    onCloseAction();
  };

  const tableDataMemo = useMemo(async () => {
    return new QuoteSevices().getGroupPriceHistory(item.supplierProductcode, item.crmCustomerCode)
      .then((res) => {
        const data = res.data.data;
        setTableData(data);
        return data;
      }).finally(() => {
        setFinishedLoadingTableData(true);
      });
  }, []);

  const onClosePriceHistoryModal = () => {
    onCloseAction();
  };

  async function saveCompetitorPrice(valueCompetitorPrice: string) {
    setVisible(true);

    let mapUpdateCompetitorPrice: IUpdateCompetitorPrice = {
      price: valueCompetitorPrice,
      hospitalProductCode: item.hospitalProductCode,
      supplierProductCode: item.productsSuggestion[0].supplierProductcode,
      hospitalDocumentNumber: item.buyerIdentifier,
      origin: "Bionexo"
    };

    const response = await new quoteMapProductSevices().UpdateCompetitorPrice(mapUpdateCompetitorPrice);

    if (response.status === 200) {
      setCompetitorPrice({
        price: currencyOutputNumber(Number(valueCompetitorPrice.replace(",", "."))),
        date: DateOutputStr(new Date().toISOString(), 'dd/MM/yyyy - HH:mm')
      });

    }
    else
      toastify.error("Não foi possível atualizar o preço do concorrente");

    setVisible(false);
  };

  const listMinimumPrice = (itemStock: any) => {
    return itemStock.map((item: any, index: number) => (
      <button key={item.unitCode}>
        <Column key={item.unitCode} className="cdPrice">
          <Row className="pt-1">
            <Text className="priceLabel">
              <Visibility visible={!IsNullOrEmpty(item.idealBillingLocation)}><span>{index + 1}º - </span></Visibility>{item.local}
            </Text>
          </Row>
          <Row className="pt-1">
            <label>Tipo 1</label>
          </Row>
          <Row>
            <Text className="PriceValue">
              {currencyOutputNumber(item?.minimumPriceLock1)}
            </Text>
          </Row>
          <Row className="pt-1">
            <label>Tipo 2</label>
          </Row>
          <Row>
            <Text className="PriceValue">
              {currencyOutputNumber(item?.minimumPriceLock2)}
            </Text>
          </Row>
        </Column>
      </button>
    ));
  };

  const displaySuggestedPrice = () => {
    if (checkSuggestedPrice) {
      return currencyOutputNumber(Number(stock?.suggestedPrice));
    }
    return "Sem preço sugerido";
  };

  const displayMinimumPriceLock1 = () => {
    if (checkMinimumPriceLock1) {
      return currencyOutputNumber(Number(stock?.minimumPriceLock1));
    }
    return "Sem preço sugerido";
  };

  const handleDisplayedSuggestedPrice = () => {
    if (item?.productSegmentDescription?.toUpperCase() === ProductSegmentDescription.MEDICINE) {
      return displaySuggestedPrice();
    } else {
      return displayMinimumPriceLock1();
    }
  };

  const applySuggestedPrice = () => {
    if (item?.productSegmentDescription?.toUpperCase() === ProductSegmentDescription.MEDICINE) {
      checkSuggestedPrice && applyUnitPrice(Number(stock?.suggestedPrice));
    } else {
      checkMinimumPriceLock1 && applyUnitPrice(Number(stock?.minimumPriceLock1));
    }
  };

  const agreementPriceVisible = stock?.agreementPrice > 0;
  const olPriceVisible = stock?.agreementPrice === 0 && stock?.olPrice > 0;
  const visiblePricing = !agreementPriceVisible && !olPriceVisible;

  var suggestedItem = item.productsSuggestion.find((product: any) => product.suggested == true);
  var valueMultiple = item?.priorityBCG?.maps?.find((map: any) => map.codProdMafra === suggestedItem?.supplierProductcode)?.multiple ?? 1;
  const showPricingButton = user?.isBCGUser && item?.priorityBCG && valueMultiple && visiblePricing;

  const calculatedPricing = useMemo(() => {
    let minimumPrice = segmentsMinimumPriceLock2.includes(item?.productSegmentDescription?.toUpperCase()) ?
      stock?.minimumPriceLock2 : stock?.minimumPriceLock1;

    return minimumPrice * valueMultiple;
  }, [item, stock]);

  const header = (
    <HeaderContent>
      <Row className="modalTitle">
        <HeaderTitle>
          <img alt="price history button" src={priceHistoryBtn} className="historyImg" />
          <Text>HISTÓRICO <em>DE PREÇO</em></Text>
        </HeaderTitle>
        <CDCloseButton onClick={() => onClosePriceHistoryModal()} />
      </Row>

      <Row className="customerInfo">
        <HeaderText className="uppercase"><em>{quoteDetail?.customerName}</em></HeaderText>
        <HeaderText>(Cód. Cliente {item.crmCustomerCode})</HeaderText>
      </Row>

      <ItemInfo>
        <Column>
          <HeaderText className="mb-2">Item</HeaderText>
          <HeaderText><em>{item.sequenceNumber}</em></HeaderText>
        </Column>
        <Column>
          <HeaderText className="mb-2">Cód.Produto</HeaderText>
          <HeaderText><em>{item.supplierProductcode}</em></HeaderText>
        </Column>
        <Column>
          <HeaderText>
            <HeaderText className="mb-2">Descrição</HeaderText>
            <Text showTip showTipContent={item.description} className="description"><em>{item.description}</em></Text>
          </HeaderText>
        </Column>
        <Column>
          <HeaderText className="mb-2">Unidade</HeaderText>
          <HeaderText><em>{item.unit}</em></HeaderText>
        </Column>
        <Column>
          <HeaderText className="mb-2">Qtd.</HeaderText>
          <HeaderText><em>{item.quantity}</em></HeaderText>
        </Column>
        <Column>
          <HeaderText>
            <HeaderText className="mb-2">Marca</HeaderText>
            <Text showTip showTipContent={item.producer}><em>{item.producer}</em></Text>
          </HeaderText>
        </Column>
        <Column>
          <HeaderText className="mb-2">Preço Fábrica</HeaderText>
          <HeaderText><em>{currencyOutputNumber(Number(item.factoryPrice))}</em></HeaderText>
        </Column>
        <Column>
          <HeaderText>Preço Sugerido</HeaderText>
          <SuggestedPrice disabled={ableNegotiacionBtn} onClick={() => applySuggestedPrice()}>
            <Text>{handleDisplayedSuggestedPrice()}</Text>
          </SuggestedPrice>
        </Column>
        <Visibility visible={agreementPriceVisible}>
          <Column>
            <HeaderText>Preço Acordo</HeaderText>
            <SuggestedPrice onClick={() => applyUnitPrice(Number(stock?.agreementPrice))}>
              <Text>{currencyOutputNumber(Number(stock?.agreementPrice))}</Text>
            </SuggestedPrice>
          </Column>
        </Visibility>
        <Visibility visible={showPricingButton}>
          <Column>
            <HeaderText>Preço Pricing</HeaderText>
            <SuggestedPrice onClick={() => applyUnitPrice(Number(calculatedPricing))}>
              <Text>{currencyOutputNumber(Number(calculatedPricing))}</Text>
            </SuggestedPrice>
          </Column>
        </Visibility>
        <Visibility visible={olPriceVisible}>
          <Column>
            <HeaderText>Preço OL</HeaderText>
            <SuggestedPrice onClick={() => applyUnitPrice(Number(stock?.olPrice))}>
              <Text>{currencyOutputNumber(Number(stock?.olPrice))}</Text>
            </SuggestedPrice>
          </Column>
        </Visibility>
      </ItemInfo>
      <PrinceInfo>
        <Column className="cdContent">
          <label>CD (organizados por ordem de CD ideal)</label>
          <Row className="listMinimumPriceSliderContainer">
            <Slider className="listMinimumPriceSlider" {...settings}>
              {listMinimumPrice(item.itemStock)}
            </Slider>
          </Row>
        </Column>
        <Column className="lastCompetitorPrice">
          <Row className="competitorPriceRow">
            <label>Último preço concorrente</label>
            <div>
              <HeaderText><em>{competitorPrice?.price ?? 'Sem informação'}</em></HeaderText>
              <span>{competitorPrice?.date}</span>
            </div>
          </Row>
          <Row className="competitorPriceRow mt-4">
            <label>Inserir preço concorrente</label>
            <InputYesOrNo disabled={ableNegotiacionBtn} onClickfunction={saveCompetitorPrice} visible={visible} />
          </Row>
        </Column>
      </PrinceInfo>
    </HeaderContent>
  );

  return (
    <PriceModal className="bg-modal">
      <Row className="modalContent">
        <ModalContainer>
          {header}
          <PriceHistoryTable
            finishedLoadingTableData={finishedLoadingTableData}
            applyPriceFunction={applyUnitPrice}
            budgetData={tableData?.historyBudget}
            salesData={tableData?.historySale} />
        </ModalContainer>
      </Row>
    </PriceModal>
  );
};

export default PriceHistoryModal;